import { defineSlotRecipe } from '@chakra-ui/react';

export const tableSlotRecipe = defineSlotRecipe({
  className: 'table',
  slots: ['root', 'header', 'columnHeader', 'body', 'row', 'cell'],
  base: {
    root: {
      fontWeight: 500,
      color: 'gray.900',
    },
    header: {
      position: 'sticky',
      top: 0,
      backgroundColor: 'white',
      zIndex: '1',
    },
    columnHeader: {
      fontFamily: 'heading',
      letterSpacing: 'wider',
      textAlign: 'start',
      padding: '3 !important',
      fontSize: 'xs',
      border: '0',
      textTransform: 'none',
      color: 'blue.60',
      fontWeight: 500,
      borderBottom: '1px solid var(--chakra-colors-gray-200)',
      borderTop: '1px solid var(--chakra-colors-gray-200)',
    },
    cell: {
      padding: '3 !important',
    },
  },
});

export default tableSlotRecipe;
